import { render, staticRenderFns } from "./DataCompletenessCards.vue?vue&type=template&id=60c3c37a&scoped=true"
import script from "./DataCompletenessCards.vue?vue&type=script&lang=js"
export * from "./DataCompletenessCards.vue?vue&type=script&lang=js"
import style0 from "./DataCompletenessCards.vue?vue&type=style&index=0&id=60c3c37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c3c37a",
  null
  
)

export default component.exports